import { NextRouter } from 'next/router';
import { getValidLocale } from './language/language.utils';
import { setLanguageCookie } from './languageCookie';

export default async function changeLocalClient(
  local: any,
  router: NextRouter
) {
  const locale = getValidLocale(local);
  setLanguageCookie(local);
  if (router.locale?.toLowerCase() === locale.toLowerCase()) {
    return;
  }
  const { slug } = router.query;
  if (router.pathname?.includes('/blog') && slug) {
    slug.slice(slug.length - 1, 2);
    const newSlug = `${slug.slice(slug.length - 1, -2)}${locale}`;
  }
  await router.replace(router.asPath, undefined, {
    locale,
  });
}
